/**
 * Service contribution reference — which NASH services contribute to each subdomain's
 * Theory of Change outcome. Transcribed from the 'Service contribution' column of the
 * Population view sheet in docs/Sample analysis.xlsx (whitespace tidied).
 *
 * This is working reference content, not whānau data. It is expected to be curated by
 * Sue / kaimahi and ultimately move into the framework reference (or the referral
 * directory list) — see REPORTING.md 'Services view'. 'poverty' is the 18th subdomain
 * added after the workbook and has no services mapped yet.
 */
import type { SubdomainId } from "../framework/types";

export const SERVICE_CONTRIBUTION: Partial<Record<SubdomainId, string[]>> = {
  "cultural-connection": [
    "Te Pou Mataaho evident in all services",
    "Ngāti Awa Open Days",
  ],
  "spiritual-connection": ["Te Pou Mataaho evident in all services"],
  "social-connection": ["Oranga Kaumatua", "Ngāti Awa Open Days"],
  relationships: [
    "Whānau Resilience",
    "Te Pūkāea o Te Waiora",
    "IIS Family and Crisis Counselling",
    "IIS Family Support",
  ],
  "support-networks": ["Pou Whānau Connector"],
  "home-environment": ["Transition to Adulthood"],
  parenting: [
    "Tamariki Ora",
    "Family Start",
    "Whakamanahia te Waiu",
    "Te Reo Karanga",
    "Te Pūkāea Whānau Navigators",
    "Shared Care - Care and Protection",
    "Kahu Taurima Midwives",
    "Kaupapa Māori Antenal Programme",
    "SUDI",
    "Incredible Years Parent Programme",
    "Incredible Years Autism Programme",
    "Whānau Resilience",
  ],
  "adult-literacy": ["Sponsorship", "Grants", "Scholarships"],
  "child-education": [
    "Social Workers in Schools",
    "Te Waipuna Ariki o Matangireia",
  ],
  "mental-health": [
    "Transition to Adulthood",
    "Health Navigator",
    "Toi Kaiawha",
    "Kahu Taurima Mental Wellbeing / Rongoa",
  ],
  "physical-health": [
    "Asthma Management",
    "Bay of Plenty Facilitation Service",
    "Contraception Service",
    "Nurse-led Kaupapa Māori CBS",
    "Health Navigator",
    "Oranga Whānau Mobile Clinic",
    "Cervical & Breast Screening",
    "Immunisations",
  ],
  "emotional-health-behaviour": [
    "Rangatahi Social Worker",
    "Youth Justice",
    "Transition to Adulthood",
  ],
  addictions: [
    "Alcohol and Drug: Kaupapa Māori Community Clinical Support Service",
    "Alcohol and Drug: Mental Health Co-existing",
    "CAYAD",
  ],
  disability: [],
  employment: ["Rukuhia Te Mahi"],
  "financial-stability": ["Discrestionary funding"],
  accommodation: ["He Tohu Kāinga", "ISS Suported Housing and Social Housing"],
  poverty: [],
};

/** All distinct services mentioned, sorted. */
export const ALL_SERVICES: string[] = Array.from(
  new Set(
    Object.values(SERVICE_CONTRIBUTION).flat().filter(Boolean) as string[],
  ),
).sort((a, b) => a.localeCompare(b));
